import BaseCommand from "@/models/api/commands/BaseCommand";

export class CheckBeforeSaveCommand extends BaseCommand {
  CommandName = "CheckBeforeSave";
  constructor(sessionId: string, operationId: string) {
    super(sessionId, operationId);
  }
}
